<template lang="pug" src="./html/NikeWeChatCampaigns-Body.pug"></template>

<script>
  import PortfolioItemBase from './PortfolioItemBase'

  export default {
    extends: PortfolioItemBase,
    mounted () {
      this.setupVideo('292879850', 'https://player.youku.com/embed/XMzg0NjgyNTc2NA==')
    }
  }
</script>

<style scoped>
    .video {
        margin: 1em 0 2em 0;
        height: 150vw;
    }
    .video .cover {
        background: rgba(255, 255, 255, 0.01)
    }
    .video .loading {
        background: #FFFFFF;
    }
    .images.amd {
        background: #c4dfe3;
    }
    .images.shm {
        background: #d7fd57;
    }
</style>
